import { BRAND } from "@/lib/brand";

// Compact circular badge mark (the master OpenDegree emblem). Recognisable at small sizes.
export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img
    src={BRAND.logo}
    alt="OpenDegree logo"
    className={`rounded-full object-cover bg-white ${className}`}
    loading="eager"
  />
);

// Full lockup: badge + OpenDegree wordmark. theme="dark" for dark backgrounds (footer).
export const Logo = ({ theme = "light", markClass = "h-9 w-9", textClass = "text-xl", className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark className={markClass} />
    <span className={`font-display font-extrabold tracking-tight ${textClass} ${theme === "dark" ? "text-white" : "text-ink"}`}>OpenDegree</span>
  </span>
);
